import React from 'react';
import { Video } from '../services/youtube';
import { VideoCard } from './VideoCard';
import { Loader2 } from 'lucide-react';

interface VideoGridProps {
  videos: Video[];
  loading: boolean;
  searchTerm: string;
}

export function VideoGrid({ videos, loading, searchTerm }: VideoGridProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <Loader2 className="h-8 w-8 text-indigo-600 animate-spin" />
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Searching for educational videos...
        </p>
      </div>
    );
  }

  if (videos.length === 0 && searchTerm) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600 dark:text-gray-400">
          No educational videos found for "{searchTerm}". Try a different search term.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
      {videos.length > 0 && (
        <div className="col-span-full text-center mt-4 text-sm text-gray-500 dark:text-gray-400">
          Showing top {videos.length} educational videos for "{searchTerm}"
        </div>
      )}
    </div>
  );
}
